import React, { useEffect, useState } from 'react'
import DefaultLayout from '../reusableComponents/defaultLayout'
import AccountHeader, { subContractorTabs } from '../components/account/AccountHeader';
import PendingProjects from '../components/account-components/pendingProjects';
import ActiveProjects from '../components/account-components/activeProjects';
import GenttChart from '../components/genttChart';
import Profile from '../components/profile';
import { useNavigate, useParams } from 'react-router-dom';
import FindAProject from '../components/account-components/findAProject';

export default function SubContractor() {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const { tabId } = useParams();

    useEffect(() => {
        const initialTabId = (0 <= tabId && tabId <= 4) ? parseInt(tabId) : 0;
        setActiveTab(initialTabId);
    }, [tabId]);

    const handleTabChange = (tabId) => {
        // Handle dashboard tab specially - it has its own route
        if (tabId === 'dashboard') {
            navigate('/dashboard');
            return;
        }
        setActiveTab(tabId);
        navigate(`/account/${tabId}`);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return <Profile />;
            case 1:
                return <PendingProjects />;
            case 2:
                return <ActiveProjects />;
            case 3:
                return <GenttChart role="subContractor" />;
            case 4:
                return <FindAProject />;
            default:
                return null;
        }
    };

    return (
        <DefaultLayout>
            <AccountHeader 
                activeTab={activeTab} 
                onTabChange={handleTabChange} 
                tabs={subContractorTabs}
            />
            <section className="account_content">
                {renderTabContent()}
            </section>
        </DefaultLayout>
    );
}
